import React, { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router";
import swal from "sweetalert";
import { API } from "../../API";
import ClipLoader from "react-spinners/ClipLoader";
import { Link } from "react-router-dom";
import { isAutheticated } from "./authhelper";

export default function StaffForgotPassword() {
  const history = useHistory();
  const [email, setEmail] = useState("");

  const [loading, setLoading] = useState(false);
  const { token } = isAutheticated();

  const [errors, setErrors] = useState({
    emailError: "",
    passwordError: "",
  });

  const handleChange = (e) => {
    e.preventDefault();

    const { name, value } = e.target;

    setEmail(value)
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);


      const response = await axios.patch(
        `${API}/api/staff/forgotpassword`,
        { email }
      );
      setEmail("")
      swal({
        title: "Updated Successfully!",
        text: "Password generated and sended to your email Successfully",
        icon: "success",
        buttons: true,
        dangerMode: false,
      })


      setLoading(null);
      // }, [2000])
    } catch (err) {
      setLoading(null);
      console.log(err.response)
      if (err.response?.data?.message) {
        swal({
          title: "Error",
          text: err.response.data.message,
          icon: "error",
          buttons: true,
          dangerMode: true,
        });
      } else {
        swal({
          title: "Error",
          text: "Can't generate password",
          icon: "error",
          buttons: true,
          dangerMode: true,
        });
      }
      console.log("this is an error", err);
    }
  };



  return (
    <div className="authentication-bg h-100">
      <div className="account-pages pt-sm-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center">
                <a
                  href="https://tellytell.com"
                  className="mb-5 d-block auth-logo"
                >
                  <img
                    src="assets/images/logo-dark.png"
                    alt=""
                    height="25"
                    className="logo logo-dark"
                  />
                  <img
                    src="assets/images/logo-light.png"
                    alt=""
                    height="25"
                    className="logo logo-light"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="row align-items-center justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card">
                <div className="card-body p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary welcome-text">
                      Forgot Password for Staff
                    </h5>
                    <p className="text-muted">you will get new password on email</p>
                  </div>
                  <div className="p-2 mt-4">
                    <form>
                      <div className="form-group">
                        <label for="username">Email</label>
                        <input
                          type="email"
                          onChange={handleChange}
                          name="email"
                          value={email}
                          required
                          className="form-control input-field"
                          placeholder="Enter Email ID"
                        />
                      </div>

                      <div className="mt-3 text-right">
                        <a href="/dashboard">
                          <button
                            onClick={handleSubmit}
                            className="
                              btn btn-primary
                              w-sm
                              waves-effect waves-light
                            "
                          >
                            <ClipLoader
                              color="blue"
                              loading={loading}
                              size={20}
                            />
                            {!loading && "Submit"}
                          </button>
                        </a>
                      </div>

                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
